<template>
  <v-dialog v-model="isOpen" persistent width="1000">
    <v-card class="elevation-4" style="border-radius: 12px; overflow: hidden;">
      <!-- Header con gradiente -->
      <v-card-title class="primary white--text pa-6"
        style="background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);">
        <v-row align="center" no-gutters>
          <v-col>
            <div class="d-flex align-center">
              <v-icon large color="white" class="mr-3">mdi-file-upload</v-icon>
              <div>
                <h2 class="text-h5 font-weight-bold mb-1">
                  Importación Masiva de Saldos / Deudas
                </h2>
                <p class="mb-0 caption" style="opacity: 0.9;">
                  Descargue la plantilla, complete los datos y cargue el archivo
                </p>
              </div>
            </div>
          </v-col>

          <div class="d-flex" style="gap: 4px;">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn class="inline-block" v-on="on" @click="createExcelTemplate" fab dark small color="success">
                  <i class="fas fa-download"></i>
                </v-btn>
              </template>
              <span>Descargar Plantilla Excel</span>
            </v-tooltip>
            <v-btn class="inline-block" fab dark small color="primary" @click="closeDialog">
              <v-icon dark>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-row>
      </v-card-title>

      <!-- Filtro Campaña y Tipo de Deuda -->
      <v-container class="mt-2">
        <v-row justify="start">
          <v-col cols="12" sm="6" md="4">
            <s-select-campaign-area label="Campaña de Destino" v-model="filter.CmaID" noDefault clearable typeArea="1"
              full />
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <s-select-definition label="Tipo de Deuda" v-model="filter.TypeDebt" :def="1697" clearable />
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <s-select-definition
              label="Tipo de Deuda"
              v-model="filter.TypeDebt"
              :def="1697"
              clearable
            />
          </v-col>
        </v-row>
      </v-container>

      <!-- Upload Zone Premium -->
      <v-container class="upload-outer pa-4">
        <input ref="fileInput" type="file" accept=".xlsx,.xls" style="display:none" @change="onFileInputChange" />

        <div
          class="dropzone"
          :class="{ 'dropzone--drag': isDragging, 'dropzone--ready': !!excelFile }"
          @dragover.prevent="isDragging = true"
          @dragleave.prevent="isDragging = false"
          @drop.prevent="onDrop"
          @click="triggerFileInput"
        >
          <!-- Orbs decorativos de fondo -->
          <span class="orb orb--1"></span>
          <span class="orb orb--2"></span>
          <span class="orb orb--3"></span>

          <!-- Grid lines overlay -->
          <span class="grid-overlay"></span>

          <!-- ===== ESTADO VACÍO ===== -->
          <transition name="fade-up" mode="out-in">
            <div v-if="!excelFile" key="empty" class="dz-content">

              <!-- Icono con anillo orbital -->
              <div class="dz-icon-ring" :class="{ 'dz-icon-ring--spin': isDragging }">
                <div class="ring ring--outer"></div>
                <div class="ring ring--mid"></div>
                <div class="dz-icon-core">
                  <v-icon size="32" color="white">{{ isDragging ? 'mdi-arrow-collapse-down' : 'mdi-cloud-upload' }}</v-icon>
                </div>
              </div>

              <!-- Textos -->
              <p class="dz-title">{{ isDragging ? '¡Suelta el archivo aquí!' : 'Cargar Plantilla de Saldos' }}</p>
              <p class="dz-subtitle">
                Arrastra tu archivo o
                <span class="dz-link" @click.stop="triggerFileInput">explora tu equipo</span>
              </p>

              <!-- Pills de formato -->
              <div class="dz-pills">
                <span class="dz-pill">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-1 1.5L18.5 9H13V3.5zM6 20V4h5v7h7v9H6z"/></svg>
                  .xlsx
                </span>
                <span class="dz-pill-sep">·</span>
                <span class="dz-pill">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-1 1.5L18.5 9H13V3.5zM6 20V4h5v7h7v9H6z"/></svg>
                  .xls
                </span>
              </div>

            </div>

            <!-- ===== ESTADO CON ARCHIVO ===== -->
            <div v-else key="ready" class="dz-ready" @click.stop>
              <!-- Icono check animado -->
              <div class="dz-check-ring">
                <svg class="dz-check-svg" viewBox="0 0 52 52">
                  <circle class="dz-check-circle" cx="26" cy="26" r="24" fill="none"/>
                  <path class="dz-check-mark" fill="none" d="M14 27 l8 8 l16-16"/>
                </svg>
              </div>

              <!-- Info del archivo -->
              <div class="dz-file-meta">
                <p class="dz-file-name">{{ excelFile.name }}</p>
                <div class="dz-file-stats">
                  <span class="dz-file-size">{{ (excelFile.size / 1024).toFixed(1) }} KB</span>
                  <span class="dz-file-dot"></span>
                  <span class="dz-file-status">Listo para importar</span>
                </div>

                <!-- Mini barra de "carga" decorativa -->
                <div class="dz-progress-bar">
                  <div class="dz-progress-fill"></div>
                </div>
              </div>

              <!-- Botón quitar -->
              <button class="dz-remove-btn" @click.stop="removeFile" title="Quitar archivo">
                <v-icon size="18" color="white">mdi-close</v-icon>
              </button>
            </div>
          </transition>
        </div>
      </v-container>

      <AlertSunshine :dialog="loadingImport" />

      <!-- Vista previa de datos -->
      <v-container v-if="headersData.length > 0">
        <v-row justify="center">
          <v-col cols="12">
            <v-card outlined style="border-radius: 8px;">
              <v-card-title class="pb-2">
                <v-icon color="primary" class="mr-2">mdi-table-eye</v-icon>
                <span class="text-h6 font-weight-medium">Vista Previa de Deudas a Importar</span>
                <v-spacer></v-spacer>

                <v-chip color="info" outlined small>
                  {{ headersData.length }} registros
                </v-chip>

                <v-chip color="error" outlined small class="ml-2" v-if="totalErrores > 0">
                  {{ totalErrores }} filas con errores
                </v-chip>
              </v-card-title>

              <v-divider></v-divider>

              <v-card-text class="pa-0">
                <v-data-table :headers="headersTablePreview" :items="filteredRows()" :items-per-page="10"
                  class="elevation-0" loading-text="Cargando vista previa...">
                  <!-- Formato de Errores en tabla -->
                  <template v-slot:item.errorMessages="{ item }">
                    <span v-if="item.errorMessages" class="red--text font-weight-medium">
                      {{ item.errorMessages }}
                    </span>
                    <span v-else class="green--text font-weight-medium">Válido</span>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <!-- Sección de acciones -->
        <v-row v-if="totalErrores === 0 && filter.CmaID > 0 && filter.TypeDebt > 0" class="mt-4">
          <v-col cols="12">
            <div class="d-flex justify-end">
              <v-btn large outlined color="grey darken-1" class="mr-3 text-none" @click="closeDialog">
                <v-icon left>mdi-close</v-icon>
                Cancelar
              </v-btn>
              <v-btn large color="success" class="text-none px-8" @click="saveExcel" :loading="savingData"
                :disabled="savingData">
                <v-icon left>mdi-content-save</v-icon>
                Guardar Saldos
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import _ProducerOldDebtsService from "@/services/Technicalassistance/ProducerOldDebtsService";
import _sProducerService from "@/services/Technicalassistance/ProducerService";
import SSelectDefinition from "@/components/Utils/SSelectDefinition";

export default {
  name: "ProducerOldDebtsImportModal",
  components: {
    SSelectDefinition,
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      filter: {
        CmaID: null,
        TypeDebt: null,
      },
      excelFile: null,
      isDragging: false,
      loadingImport: false,
      savingData: false,
      headersData: [],
      headersTablePreview: [
        { text: "Fila", value: "Fila", width: 60, align: "center" },
        { text: "Nro. Documento", value: "NumeroDocumento", width: 140 },
        { text: "Productor (PrdCardName)", value: "PrdCardName" },
        { text: "Fecha Emisión", value: "FechaEmision", width: 120, align: "center" },
        { text: "Monto Total", value: "MontoTotal", width: 120, align: "end" },
        { text: "Observación", value: "Observacion" },
        { text: "Errores/Estado", value: "errorMessages", width: 220 },
      ],
    };
  },
  computed: {
    totalErrores() {
      return this.headersData.filter((row) => row.errors && row.errors.length > 0).length;
    },
  },
  methods: {
    triggerFileInput() {
      if (!this.excelFile) {
        this.$refs.fileInput.click();
      }
    },
    onFileInputChange(e) {
      const file = e.target.files[0];
      if (file) {
        this.excelFile = file;
        this.handleFileSelect();
      }
      // Reset input so the same file can be re-selected
      e.target.value = null;
    },
    onDrop(e) {
      this.isDragging = false;
      const file = e.dataTransfer.files[0];
      if (file && (file.name.endsWith('.xlsx') || file.name.endsWith('.xls'))) {
        this.excelFile = file;
        this.handleFileSelect();
      } else if (file) {
        this.$fun.alert('Solo se permiten archivos .xlsx o .xls', 'warning');
      }
    },
    removeFile() {
      this.excelFile = null;
      this.headersData = [];
      if (this.$refs.fileInput) this.$refs.fileInput.value = null;
    },
    closeDialog() {
      this.excelFile = null;
      this.headersData = [];
      this.$emit("update:isOpen", false);
      this.$emit("close");
    },
    createExcelTemplate() {
      try {
        const ExcelJS = require("exceljs");
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Datos Generales");

        const headers = ["NUMERO_DOCUMENTO", "FECHA_EMISION", "MONTO_TOTAL", "OBSERVACION"];
        worksheet.addRow(headers);

        // Estilo de encabezados
        worksheet.getRow(1).eachCell((cell) => {
          cell.style = {
            font: { bold: true, color: { argb: "FFFFFFFF" } },
            fill: { type: "pattern", pattern: "solid", fgColor: { argb: "FF1976D2" } },
            alignment: { vertical: "middle", horizontal: "center" },
          };
        });

        // Configuración de anchos de columna
        worksheet.columns = [
          { width: 22 },
          { width: 18 },
          { width: 18 },
          { width: 40 },
        ];

        // Definir formatos explícitos
        worksheet.getColumn(1).numFmt = "@";
        worksheet.getColumn(3).numFmt = "0.00";

        // Fila de ejemplo
        worksheet.addRow(["20485741235", "2026-05-28", 1500.50, "Ejemplo de observación de saldo antiguo"]);

        workbook.xlsx.writeBuffer().then((buffer) => {
          const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = "Plantilla_Saldos_Antiguos.xlsx";
          link.click();
        });
      } catch (error) {
        console.error(error);
        this.$fun.alert("Error al generar la plantilla", "error");
      }
    },
    handleFileSelect() {
      if (!this.excelFile) {
        this.headersData = [];
        return;
      }

      this.loadingImport = true;
      try {
        const ExcelJS = require("exceljs");
        const reader = new FileReader();

        reader.onload = async (e) => {
          const workbook = new ExcelJS.Workbook();
          await workbook.xlsx.load(e.target.result);

          const ws = workbook.getWorksheet("Datos Generales");
          if (!ws) {
            this.$fun.alert("No existe la hoja 'Datos Generales'", "error");
            this.loadingImport = false;
            return;
          }

          const rawRows = [];
          const headers = ws.getRow(1).values.slice(1).map((h) => h?.toString().trim());

          ws.eachRow({ includeEmpty: true }, (row, rowNumber) => {
            if (rowNumber === 1) return;

            const rowData = {};
            let hasData = false;

            row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
              let value = cell.value;
              if (value && typeof value === "object" && value.result !== undefined) {
                value = value.result;
              }
              if (value !== null && value !== undefined && value !== "") {
                hasData = true;
              }
              const header = headers[colNumber - 1];
              if (header) rowData[header] = value;
            });

            if (hasData) {
              rowData.Fila = rowNumber;
              rawRows.push(rowData);
            }
          });

          // Procesar y validar asíncronamente con el servicio getproducer
          const validatedRows = await Promise.all(
            rawRows.map(async (row) => {
              const errors = [];
              let prdCardName = "";
              let prdID = null;

              const docNum = row.NUMERO_DOCUMENTO ? row.NUMERO_DOCUMENTO.toString().trim() : "";

              if (!docNum) {
                errors.push("El número de documento es requerido");
              } else {
                try {
                  const res = await _sProducerService.getproducer(docNum);
                  if (res && res.data && res.data.PrdID) {
                    prdID = res.data.PrdID;
                    prdCardName = res.data.PrdCardName;
                  } else {
                    errors.push("Productor no encontrado");
                  }
                } catch (error) {
                  errors.push("Error al validar productor");
                }
              }

              let fechaEmision = row.FECHA_EMISION;
              const montoTotal = row.MONTO_TOTAL;

              if (!fechaEmision) {
                errors.push("Fecha de emisión es requerida");
              } else if (fechaEmision instanceof Date) {
                // Formatear Date a yyyy-MM-dd
                const year = fechaEmision.getFullYear();
                const month = String(fechaEmision.getMonth() + 1).padStart(2, "0");
                const day = String(fechaEmision.getDate()).padStart(2, "0");
                fechaEmision = `${year}-${month}-${day}`;
              } else {
                fechaEmision = fechaEmision.toString().trim();
              }

              if (montoTotal === undefined || montoTotal === null || isNaN(montoTotal) || Number(montoTotal) < 0) {
                errors.push("Monto total debe ser mayor o igual a cero");
              }

              return {
                Fila: row.Fila,
                NumeroDocumento: docNum,
                PrdCardName: prdCardName || "-",
                PrdID: prdID,
                FechaEmision: fechaEmision || "",
                MontoTotal: montoTotal || 0,
                Observacion: row.OBSERVACION || "",
                errors,
                errorMessages: errors.join("; "),
              };
            })
          );

          this.headersData = validatedRows;
          this.loadingImport = false;
          this.$fun.alert(`Cargados ${this.headersData.length} registros para validación`, "success");
        };

        reader.readAsArrayBuffer(this.excelFile);
      } catch (error) {
        this.loadingImport = false;
        this.$fun.alert("Error al procesar el archivo Excel", "error");
      }
    },
    filteredRows() {
      return this.headersData;
    },
    async saveExcel() {
      this.savingData = true;

      if (!this.filter.CmaID) {
        this.$fun.alert("Seleccione la Campaña antes de guardar", "warning");
        this.savingData = false;
        return;
      }

      if (!this.filter.TypeDebt) {
        this.$fun.alert("Seleccione el Tipo de Deuda antes de guardar", "warning");
        this.savingData = false;
        return;
      }

      try {
        const payload = this.headersData.map((row) => {
          return {
            PdeID: 0,
            IssueDate: row.FechaEmision,
            PrdID: row.PrdID,
            CmaID: this.filter.CmaID,
            TypeDebt: this.filter.TypeDebt,
            TotalAmount: Number(row.MontoTotal),
            TotalBalance: Number(row.MontoTotal),
            StatusBalance: 1, // 1 = Pendiente
            Observation: row.Observacion,
            SecStatus: 1,
            UsrCreateID: parseInt(this.$fun.getUserID()),
          };
        });

        if (payload.length === 0) {
          this.$fun.alert("No hay datos válidos para guardar", "warning");
          this.savingData = false;
          return;
        }

        const r = await _ProducerOldDebtsService.saveList(payload, this.$fun.getUserID());
        const esSuccess = r && (r.status === 200 || r.status === 201 || r.status === 204 || !r.status);

        if (esSuccess) {
          this.$fun.alert(`¡Excelente! ${payload.length} registros guardados correctamente`, "success");
          this.excelFile = null;
          this.headersData = [];
          this.closeDialog();
        }
      } catch (err) {
        const mensaje =
          err.response?.data?.Message ||
          err.response?.data?.message ||
          err.response?.data ||
          err.message ||
          "Error al guardar los registros masivos";
        this.$fun.alert(mensaje, "error");
      } finally {
        this.savingData = false;
      }
    },
  },
};
</script>

<style scoped>
/* ============================================================
   PREMIUM DROP ZONE
   ============================================================ */

/* Wrapper externo */
.upload-outer { padding: 0 12px 8px; }

/* ---- Base del dropzone ---- */
.dropzone {
  position: relative;
  overflow: hidden;
  min-height: 200px;
  border-radius: 20px;
  border: 1.5px solid rgba(25, 118, 210, 0.22);
  background: linear-gradient(145deg, #f0f7ff 0%, #e8f3fc 55%, #eef5fb 100%);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 24px;
  transition: border-color 0.3s ease, box-shadow 0.3s ease, transform 0.25s ease;
  user-select: none;
  box-shadow:
    0 0 0 1px rgba(25,118,210,0.06),
    0 6px 24px rgba(25,118,210,0.08),
    inset 0 1px 0 rgba(255,255,255,0.9);
}

.dropzone:hover {
  border-color: rgba(25, 118, 210, 0.55);
  box-shadow:
    0 0 0 1px rgba(25,118,210,0.14),
    0 10px 32px rgba(25,118,210,0.1),
    0 0 40px rgba(25,118,210,0.06),
    inset 0 1px 0 rgba(255,255,255,1);
  transform: translateY(-2px);
}

/* Drag activo */
.dropzone--drag {
  border-color: #1976d2 !important;
  background: linear-gradient(145deg, #dbeeff 0%, #cce4fa 55%, #d6ecff 100%) !important;
  box-shadow:
    0 0 0 2px rgba(25,118,210,0.25),
    0 10px 36px rgba(25,118,210,0.16),
    0 0 60px rgba(25,118,210,0.1) !important;
  transform: scale(1.012) translateY(-2px) !important;
}

/* Archivo listo */
.dropzone--ready {
  border-color: rgba(46, 125, 50, 0.35);
  background: linear-gradient(145deg, #f1faf4 0%, #e6f7ec 55%, #edf9f1 100%);
  cursor: default;
}
.dropzone--ready:hover {
  border-color: rgba(46, 125, 50, 0.55);
  box-shadow:
    0 0 0 1px rgba(46,125,50,0.12),
    0 10px 32px rgba(46,125,50,0.1),
    0 0 40px rgba(46,125,50,0.06),
    inset 0 1px 0 rgba(255,255,255,1);
  transform: translateY(-2px);
}

/* ---- Orbs decorativos de fondo ---- */
.orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(60px);
  pointer-events: none;
  opacity: 0.18;
  animation: orbFloat 8s ease-in-out infinite alternate;
}
.orb--1 {
  width: 220px; height: 220px;
  background: radial-gradient(circle, #90caf9, transparent);
  top: -60px; left: -60px;
  animation-delay: 0s;
  opacity: 0.22;
}
.orb--2 {
  width: 160px; height: 160px;
  background: radial-gradient(circle, #64b5f6, transparent);
  bottom: -50px; right: -40px;
  animation-delay: -3s;
  opacity: 0.18;
}
.orb--3 {
  width: 100px; height: 100px;
  background: radial-gradient(circle, #bbdefb, transparent);
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
  animation-delay: -5s;
  opacity: 0.14;
}
@keyframes orbFloat {
  from { transform: translate(0, 0) scale(1); }
  to   { transform: translate(12px, -12px) scale(1.08); }
}

/* Grid overlay */
.grid-overlay {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background-image:
    linear-gradient(rgba(25,118,210,0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(25,118,210,0.05) 1px, transparent 1px);
  background-size: 32px 32px;
  border-radius: inherit;
}

/* ---- Contenido base ---- */
.dz-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  text-align: center;
  position: relative;
  z-index: 1;
}

/* ---- Anillo orbital del ícono ---- */
.dz-icon-ring {
  position: relative;
  width: 90px;
  height: 90px;
  margin-bottom: 4px;
  transition: transform 0.3s ease;
}
.dz-icon-ring--spin .ring--outer { animation-duration: 1.6s !important; }

.ring {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 1.5px solid transparent;
}
.ring--outer {
  border-top-color: rgba(99, 179, 237, 0.8);
  border-right-color: rgba(99, 179, 237, 0.3);
  animation: spinCW 3.2s linear infinite;
}
.ring--mid {
  inset: 10px;
  border-bottom-color: rgba(25, 118, 210, 0.7);
  border-left-color: rgba(25, 118, 210, 0.25);
  animation: spinCCW 2.4s linear infinite;
}
@keyframes spinCW  { to { transform: rotate(360deg); } }
@keyframes spinCCW { to { transform: rotate(-360deg); } }

.dz-icon-core {
  position: absolute;
  inset: 16px;
  border-radius: 50%;
  background: linear-gradient(135deg, #1565c0 0%, #0288d1 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 16px rgba(25,118,210,0.45), 0 0 0 4px rgba(25,118,210,0.1);
}

/* ---- Textos estado vacío ---- */
.dz-title {
  font-size: 1.05rem;
  font-weight: 700;
  color: #0d47a1;
  margin: 0;
  letter-spacing: 0.02em;
  text-shadow: 0 1px 4px rgba(255,255,255,0.8);
}
.dz-subtitle {
  font-size: 0.8rem;
  color: #546e7a;
  margin: 0;
}
.dz-link {
  color: #1565c0;
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
  transition: color 0.2s;
}
.dz-link:hover { color: #0d47a1; }

/* Pills de formato */
.dz-pills {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
}
.dz-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: rgba(25,118,210,0.08);
  border: 1px solid rgba(25,118,210,0.2);
  border-radius: 20px;
  padding: 3px 10px;
  font-size: 0.7rem;
  font-weight: 700;
  color: #1565c0;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}
.dz-pill-sep {
  color: rgba(25,118,210,0.3);
  font-size: 0.9rem;
}

/* ---- Estado READY (con archivo) ---- */
.dz-ready {
  display: flex;
  align-items: center;
  gap: 18px;
  width: 100%;
  position: relative;
  z-index: 1;
}

/* Check ring animado */
.dz-check-ring {
  flex-shrink: 0;
  width: 64px;
  height: 64px;
}
.dz-check-svg { width: 100%; height: 100%; }

.dz-check-circle {
  stroke: #48c78e;
  stroke-width: 2.5;
  stroke-dasharray: 160;
  stroke-dashoffset: 0;
  animation: drawCircle 0.6s ease forwards;
}
.dz-check-mark {
  stroke: #48c78e;
  stroke-width: 3;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-dasharray: 40;
  stroke-dashoffset: 0;
  animation: drawCheck 0.4s 0.4s ease forwards;
}
@keyframes drawCircle {
  from { stroke-dashoffset: 160; opacity: 0.3; }
  to   { stroke-dashoffset: 0;   opacity: 1;   }
}
@keyframes drawCheck {
  from { stroke-dashoffset: 40; }
  to   { stroke-dashoffset: 0;  }
}

/* Metadatos del archivo */
.dz-file-meta { flex: 1; min-width: 0; }

.dz-file-name {
  font-size: 0.9rem;
  font-weight: 700;
  color: #1b5e20;
  margin: 0 0 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dz-file-stats {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 10px;
}
.dz-file-size {
  font-size: 0.72rem;
  font-weight: 600;
  color: #2e7d32;
}
.dz-file-dot {
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: rgba(46,125,50,0.4);
}
.dz-file-status {
  font-size: 0.72rem;
  color: #388e3c;
}

/* Barra de progreso decorativa */
.dz-progress-bar {
  height: 3px;
  border-radius: 4px;
  background: rgba(72,199,142,0.12);
  overflow: hidden;
}
.dz-progress-fill {
  height: 100%;
  border-radius: 4px;
  background: linear-gradient(90deg, #48c78e, #06d6a0);
  animation: fillBar 0.7s 0.2s cubic-bezier(.4,0,.2,1) both;
}
@keyframes fillBar {
  from { width: 0%; }
  to   { width: 100%; }
}

/* Botón quitar */
.dz-remove-btn {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: rgba(255,82,82,0.18);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;
}
.dz-remove-btn:hover {
  background: rgba(255,82,82,0.36);
  transform: scale(1.1);
}

/* ---- Transición fade-up ---- */
.fade-up-enter-active, .fade-up-leave-active { transition: opacity 0.28s ease, transform 0.28s ease; }
.fade-up-enter  { opacity: 0; transform: translateY(12px); }
.fade-up-leave-to { opacity: 0; transform: translateY(-8px); }

/* ---- Responsive ---- */
@media (max-width: 600px) {
  .dropzone { min-height: 170px; padding: 22px 16px; }
  .dz-icon-ring { width: 72px; height: 72px; }
  .dz-title { font-size: 0.92rem; }
  .dz-subtitle { font-size: 0.74rem; }
  .dz-ready { gap: 12px; }
  .dz-check-ring { width: 52px; height: 52px; }
  .dz-file-name { font-size: 0.8rem; }
}
</style>
